import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEOHead from '../components/SEOHead';
import { SITE_PHONE_DISPLAY, SITE_PHONE_TEL } from '../constants/site';

export default function QuoteConfirmationPage() {
  const hasTrackedLeadRef = useRef(false);

  if (!hasTrackedLeadRef.current && typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'Lead');
    hasTrackedLeadRef.current = true;
  }

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="quote-confirmation-page">
      <SEOHead
        title="Quote Request Received | Flash Funding"
        description="Thanks for your quote request. A broker will call within 30 minutes during business hours."
        canonical="/quote-confirmation"
      />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="quote-confirmation-main-section">
        <div className="rounded-3xl border border-emerald-500/30 bg-emerald-500/10 p-8 text-center">
          <CheckCircle2 size={44} className="mx-auto text-emerald-300 mb-4" />
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-3">Thanks — request received</h1>
          <p className="text-white/80 text-sm sm:text-base mb-6">A broker will call within 30 minutes during business hours.</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/" data-testid="quote-confirmation-home-link">
              <Button className="rounded-full bg-purple-600 hover:bg-purple-500 text-white text-xs uppercase tracking-[0.14em] font-bold px-7 py-6" data-testid="quote-confirmation-home-cta">
                Back to homepage
              </Button>
            </Link>
            <a href={SITE_PHONE_TEL} data-testid="quote-confirmation-call-link">
              <Button variant="outline" className="rounded-full border-purple-400/40 bg-navy-800 text-white hover:bg-purple-500/15 text-xs uppercase tracking-[0.14em] font-bold px-7 py-6" data-testid="quote-confirmation-call-cta">
                Call {SITE_PHONE_DISPLAY}
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
